<template>
  <v-form>
    <validation-observer ref="observer">
      <v-form ref="form" @submit.prevent="handleSubmit">
        <validation-provider
          v-slot="{ errors }"
          name="name"
          :rules="rules.name"
        >
          <v-text-field
            v-model="formData.name"
            :error-messages="errors"
            label="ปี"
            outlined
            dense
          ></v-text-field>
        </validation-provider>
        <div class="text-right">
          <v-btn color="primary" @click="onClose" text> ปิด </v-btn>
          <v-btn color="primary" :loading="submitLoading" type="submit">
            บันทึก
          </v-btn>
        </div>
      </v-form>
    </validation-observer>
  </v-form>
</template>

<script>
import { mapGetters } from "vuex"
import _ from "lodash"
import { UPDATE_YEAR } from "@/store/action.type"
import { formValidateError } from "@/common/helper"

export default {
  name: "FormEditYear",
  props: {
    year: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      formData: {
        name: "",
      },
      rules: {
        name: "required|max:100",
      },
      submitLoading: false,
    }
  },
  computed: {
    ...mapGetters(["yearError"]),
  },
  watch: {
    year() {
      this.setYear()
    },
  },
  mounted() {
    this.setYear()
  },
  methods: {
    setYear() {
      this.formData.name = this.year.name
    },
    onClose() {
      this.$emit("onClose", false)
    },
    async handleSubmit() {
      this.submitLoading = true
      const validated = await this.$refs.observer.validate()

      if (validated) {
        await this.$store.dispatch(UPDATE_YEAR, {
          year_id: this.year.id,
          data: this.formData,
        })

        if (!_.isEmpty(this.yearError)) {
          formValidateError(this, this.yearError)
        } else {
          this.onClose()
        }
      }

      this.submitLoading = false
    },
  },
}
</script>